export default __webpack_public_path__ + "static/media/activity.82281641.svg";